import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const AuthRoutes = () => {
  const { token, user } = useSelector((state) => state.AuthReducer);
  const location = useLocation();

  if (token && user) {
    
    if (location.pathname === "/") {
      if (user.role_name === "Admin") return <Navigate to="/manage-companies" replace />;
      if (user.role_name === "SalesAdmin") return <Navigate to="/dashboard-sales" replace />;
      if (user.role_name === "TenantAdmin") return <Navigate to="/dashboard" replace />;
      return <Navigate to="/dashboard" replace />; 
    }

    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default AuthRoutes;
